export default {
  loginSuccess: "loginSuccess",
  logout: "logout",
  setNavigation: "setNavigation",
};
